// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"b6de966a","178":"feb43446","205":"c9f313b1","312":"b1d0992f","551":"c2ddb01f","675":"ad51873d","800":"d79d84e4","828":"6cc522b3","873":"40b4e8fb"}[chunkId] + ".chunk.js";
};